import * as React from 'react';
import { Route, Switch } from 'react-router-dom';

import { SiteContextProvider } from './components/utils/context/SiteContext';
import { createGlobalStyle } from 'styled-components';
import { RedirectToFullURL } from './components/containers/RedirectFullURL';
import ServerError from './components/containers/Error';
import NybyggProfile from './components/containers/NybyggProfile';
import Preview from './components/containers/Preview';
import NoMatch from './components/containers/NoMatch';
import Visningspaamelding from './components/containers/Visningspaamelding';

export const App: React.FC = () => {
  return (
    <SiteContextProvider>
      <GlobalStyles />
      <Switch>
        <Route exact path="/preview/:sguid" component={Preview} />

        <Route
          exact
          path="/:urltag/:sguid(\d+)/:permalink"
          component={NybyggProfile}
        />
        <Route
          exact
          path="/:sguid(\d+)/visningspaamelding"
          component={Visningspaamelding}
        />
        <Route exact path="/:sguid(\d+)" component={RedirectToFullURL} />
        <Route exact path="/noe-gikk-galt" component={ServerError} />
        <Route exact path="/finner-ikke-side" component={NoMatch} />
        <Route component={NoMatch} />
      </Switch>
    </SiteContextProvider>
  );
};

const GlobalStyles = createGlobalStyle`
  .menu-background {
    background: #171719;
  }
`;
